import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getWorkflowRunTimeMachine } from '@/redux/requests/workflowsRequests.js';
import { automationWorkflowRunSteps } from '@/redux/selectors/pieveSelectors/automationCatalogSelectors.js';
import { workflowRunIsLoaded } from '@/redux/selectors/pieveSelectors/automationWorkflowRunLogsSelectors.js';
import RunStepList from './RunStepList.jsx';

const REFRESH_MS = 4000;

/** What a workflow run did, step by step, read from the run's step record. Refreshes while the run is still going. */
const WorkflowRunDetails = ({ workflowId, workflowRunId, isLive }) => {
  const { steps, result } = useSelector((state) => automationWorkflowRunSteps(state, workflowRunId));
  const loaded = useSelector((state) => workflowRunIsLoaded(state, workflowRunId));

  useEffect(() => {
    getWorkflowRunTimeMachine({ workflowId, workflowRunId });

    if (!isLive) {
      return undefined;
    }

    const timer = setInterval(() => getWorkflowRunTimeMachine({ workflowId, workflowRunId }), REFRESH_MS);
    return () => clearInterval(timer);
  }, [workflowId, workflowRunId, isLive]);

  return <RunStepList steps={steps} result={result} loading={!loaded} isLive={isLive} />;
};

export default WorkflowRunDetails;
